import { createLazyFileRoute } from "@tanstack/react-router";
import { memo } from "react";

import { CommandMenu, CommandMenuProvider } from "@/components/CommandMenu";
import { InsightsPage } from "@/features/admin/routes/Insights";

export const Route = createLazyFileRoute("/_auth/_app/insights/")({
  component: memo(InsightsRoot),
});

function InsightsRoot() {
  return (
    <CommandMenuProvider>
      <InsightsPage />
      <CommandMenu />
    </CommandMenuProvider>
  );
}
